<template>
  <div class="product-page">

    <!-- Hero 区域 -->
    <section class="hero">
      <div class="hero-content">
        <h2>百亩林枣林园区各大项目介绍</h2>
        <p>探索百亩林枣林园区的多个创新项目，涵盖枣酒酿造、枣木加工、枣茶代茶饮等多个领域，助力乡村振兴，创造绿色未来。</p>
      </div>
    </section>

    <section class="section featured-products">
      <h2>重点项目介绍</h2>
      <div class="product-grid">
        <div class="featured-product" v-for="(project, index) in featuredProjects" :key="index" @click="openModal(project)">
          <img :src="hoverProject === index ? project.hoverImage : project.image" :alt="project.title" />
          <h3>{{ project.title }}</h3>
          <p>{{ project.description }}</p>
        </div>
      </div>
    </section>

    <section id="features" class="section features">
      <h2>项目功能与优势</h2>
      <div class="feature-grid">
        <div class="feature-card" v-for="(feature, index) in features" :key="index">
          <strong>{{ feature.title }}</strong>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <!-- <section id="reviews" class="section reviews">
      <h2>客户评价</h2>
      <div class="review-grid">
        <div class="review-card" v-for="(review, index) in reviews" :key="index">
          <p>"{{ review.text }}"</p>
          <p><strong>{{ review.name }}</strong></p>
        </div>
      </div>
    </section> -->

    <!-- 联系我们 -->
    <section id="contact" class="section contact">
      <h2>联系我们</h2>
      <p>如果您有任何问题或需要更多信息，请随时联系我们：</p>
      <p><strong>电话：</strong> +123 456 7890</p>
      <p><strong>邮箱：</strong> contact@bailumulin.com</p>
      <p><strong>地址：</strong> 123 Green Street, Eco City, Earth</p>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
        <p>&copy; 2025 百亩林枣林园区. All rights reserved.</p>
      </div>
    </footer>

    <!-- 弹窗组件 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal" @click.stop>
        <button class="close-button" @click="closeModal">X</button>
        <h3>{{ selectedProject.title }}</h3>
        <img :src="selectedProject.image" :alt="selectedProject.title" />
        <p>{{ selectedProject.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'; // 引入 Footer 组件
export default {
  name: 'ProductPage',
  components: {
    Footer,
  },
  data() {
    return {
      hoverProject: null,
      showModal: false,
      selectedProject: {},

      features: [
        { title: '高效生产', description: '采用现代化设备和工艺，提高生产效率和产品质量。' },
        { title: '绿色环保', description: '所有项目都致力于绿色环保，推动可持续发展。' },
        { title: '增加就业', description: '每个项目都为当地村民提供大量就业机会，促进地方经济。' },
        { title: '市场前景广阔', description: '枣酒、枣木、枣茶等产品符合市场需求，具有广泛的发展潜力。' }
      ],
      featuredProjects: [
        { title: '枣酒酿造', image: require('@/assets/image/zao-jiu.jpg'), hoverImage: require('@/assets/image/zao-jiu.jpg'), description: '年产200吨枣酒原浆，采用100%红枣原料，酿制出纯正红枣白酒。' },
        { title: '枣木加工', image: require('@/assets/image/zao-mu.jpg'), hoverImage: require('@/assets/image/zao-mu.jpg'), description: '枣木工艺品和家具的生产，满足日益增长的市场需求。' },
        { title: '枣茶代茶饮', image: require('@/assets/image/zao-cha.jpg'), hoverImage: require('@/assets/image/zao-cha.jpg'), description: '采用灵宝大枣为原料，开发出多种口味的枣茶，满足不同消费者需求。' },
        { title: '天然酒窖文化体验', image: require('@/assets/image/jiu-yao.jpg'), hoverImage: require('@/assets/image/jiu-yao.jpg'), description: '12个天然酒窖，提供酿酒工艺体验、酒文化展示等互动活动。' },
        { title: '康养项目', image: require('@/assets/image/healthcare.jpg'), hoverImage: require('@/assets/image/healthcare.jpg'), description: '为中老年人和亚健康人群提供全方位的康养服务，结合酒庄美丽环境，提供健康生活服务。' },
        { title: '红枣醋产业', image: require('@/assets/image/vinegar.jpg'), hoverImage: require('@/assets/image/vinegar.jpg'), description: '年产200吨红枣醋，致力于开发健康、绿色的醋产品，满足市场需求。' },
        { title: '大枣加工', image: require('@/assets/image/daza.jpg'), hoverImage: require('@/assets/image/daza.jpg'), description: '将新鲜灵宝大枣进行加工，增加附加值，拓展市场需求。' }
      ],
      reviews: [
        { text: '百亩林的枣酒真是好喝，纯正无添加，喝了非常健康！', name: '王丽' },
        { text: '枣木家具很结实，设计也非常符合我的品味，真心推荐。', name: '赵明' }
      ]
    };
  },
  methods: {
    scrollToOverview() {
      document.getElementById("overview").scrollIntoView({ behavior: 'smooth' });
    },
    openModal(project) {
      this.selectedProject = project;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.product-page {
  font-family: 'Arial', sans-serif;
  padding-top: 40px;
  background-color: #e8f5e9; /* 偏绿色背景 */
}

.hero {
  background-image: url('@/assets/image/hero5.jpg');
  background-size: cover;
  background-position: center;
  padding: 120px 0;
  text-align: center;
  color: white;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero h2 {
  font-size: 3.5em;
  margin-bottom: 20px;
}

.hero p {
  font-size: 1.6em;
  margin-bottom: 30px;
}

.hero button {
  padding: 14px 32px;
  font-size: 1.3em;
  background-color: #00b894;
  border: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  border-radius: 8px;
}

.hero button:hover {
  background-color: #098c73;
  transform: scale(1.05);
}

.section {
  padding: 60px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.section h2 {
  font-size: 2.5em;
  margin-bottom: 30px;
  text-align: center;
  color: #333;
}

.overview .product-types {
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.product-type {
  flex: 1;
  padding: 30px;
  background-color: #f3f3f3;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.product-type:hover {
  background-color: #00b894;
  color: white;
  transform: translateY(-10px);
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.feature-card {
  padding: 20px;
  background-color: #f3f3f3;
  border-radius: 10px;
  text-align: center;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.featured-product img {
  width: 100%;
  border-radius: 10px;
  transition: transform 0.3s;
}

.featured-product:hover img {
  transform: scale(1.05);
}

.review-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.review-card {
  padding: 20px;
  background-color: #f3f3f3;
  border-radius: 10px;
  text-align: center;
}

.footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 20px 0;
  margin-top: 60px;
}

.footer-content p {
  margin: 0;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  position: relative;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  color: #333;
}

.modal h3 {
  margin-bottom: 15px;
  font-size: 1.8em;
  color: #333;
}

.modal img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 15px;
}

.modal p {
  font-size: 1em;
  color: #666;
}

.section.featured-products {
  width: 90%;
  margin: 20px auto;
  background-color: #ffffff; /* 白色背景 */
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.section.featured-products h2 {
  margin-bottom: 10px;
  text-align: center;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin-bottom: 20px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); /* 自动调整列数 */
  gap: 20px;
}

.featured-product {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  font-size: 12px;
}

.featured-product:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.featured-product img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s;
}

.featured-product:hover img {
  transform: scale(1.05);
}

.featured-product h3 {
  margin: 10px 0;
  text-align: center;
  font-size: 1.5em;
  color: #333;
}

.featured-product p {
  margin: 10px 20px;
  text-align: center;
  color: #666;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .hero {
    padding: 80px 0;
  }

  .hero h2 {
    font-size: 2.5em;
  }

  .hero p {
    font-size: 1.2em;
  }

  .section {
    padding: 40px 15px;
  }

  .section h2 {
    font-size: 2em;
    margin-bottom: 20px;
  }

  .feature-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .product-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .featured-product img {
    height: 150px;
  }

  .featured-product h3 {
    font-size: 1.2em;
  }

  .featured-product p {
    font-size: 0.9em;
    margin: 8px 15px;
  }

  .modal {
    width: 95%;
    padding: 15px;
  }

  .modal h3 {
    font-size: 1.5em;
  }

  .modal p {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 480px) {
  .hero {
    padding: 60px 0;
  }

  .hero h2 {
    font-size: 2em;
  }

  .hero p {
    font-size: 1em;
  }

  .section {
    padding: 30px 10px;
  }

  .section h2 {
    font-size: 1.8em;
  }

  .feature-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .product-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .featured-product img {
    height: 180px;
  }

  .featured-product h3 {
    font-size: 1.1em;
  }

  .featured-product p {
    font-size: 0.85em;
    margin: 6px 12px;
  }

  .modal {
    width: 98%;
    padding: 12px;
  }

  .modal h3 {
    font-size: 1.3em;
  }

  .modal p {
    font-size: 0.85em;
  }
}
</style>